import Vue from 'vue'
import axios from 'axios'
import api from '@/api'

import {
    SET_ADDRESSES,
    SET_GEO_ADDRESS,
    SET_INPUT_GEO_ADDRESS,
    SET_TOKEN,
    SET_IDENTITY,
    SET_PROFILE,
    SET_CASHBACK_SETTINGS,
    SET_GUARD_OUTLET_ID,
    SET_GUARD_PASS,
    SET_LOADING,
    SET_ADDRESS_SUGGESTIONS,
    SET_QUERY_PARAMS,
    SET_POST_CODE,
    SET_DELIVERY_TO_CITY,
    SET_IS_HAS_GEO,
    SET_DADATA_STREET,
    SET_ADDRESS_CITY,
    SET_ADDRESS_STREET,
} from '@/store/mutations.type'

import {
    GET_ADDRESSES,
    GET_GEO_ADDRESS,
    GET_INPUT_GEO_ADDRESS,
    SET_PROFILE_ADDRESS,
    SET_GLOBAL_ERROR,
    GET_ADDRESS_SUGGESTIONS,
    SET_AREA
} from '@/store/actions.type'


const GEOLOCATION_ADDRESS_ERROR = 1000

const state = {
    token: null,
    queryParams: null,
    identity: null,
    profile: null,
    addresses: null,
    addressSuggestions: [],
    geolocationAddress: null,
    inputGeoAddress: null,
    cashbackSettings: {
        available: false,
        max: 0,
        cashback_balance: 0,
        max_percents: 0,
        message: '',
        sliderData: [],
        show_message: false
    },

    loading: {
        GET_GEO_ADDRESS: false,
        GET_INPUT_GEO_ADDRESS: false,
        SET_PROFILE_ADDRESS: false
    },
    postCode: '',
    isHasGeo: false,
    dadataStreet: '',
}

const getters = {
    dadataStreet(state) {
        return state.dadataStreet
    },
    postCode(state) {
        return state.postCode
    },
    token(state) {
        return state.token
    },
    queryParams(state) {
        return state.queryParams
    },
    identity(state) {
        return state.identity
    },
    profile(state) {
        return state.profile
    },
    cashbackSettings(state) {
        return state.cashbackSettings
    },
    addresses(state) {
        return state.addresses
    },
    addressSuggestions(state) {
        return state.addressSuggestions
    },
    geolocationAddress(state) {
        return state.geolocationAddress
    },
    inputGeoAddress(state) {
        return state.inputGeoAddress
    },
    isHasGeo(state) {
        return state.isHasGeo
    },
    /**
     * @return {number}
     */
    GEOLOCATION_ADDRESS_ERROR() {
        return GEOLOCATION_ADDRESS_ERROR
    },

}


export const mutations = {
    [SET_DADATA_STREET](state, data) {
        state.dadataStreet = data
    },
    [SET_POST_CODE](state, data) {
        state.postCode = data
    },
    [SET_CASHBACK_SETTINGS](state, data) {
        let arr = []
        let val = 0
        while (data.max > val) {
            arr.push(val)
            val += 5
        }
        arr.push(data.max)

        data.sliderData = arr
        state.cashbackSettings = data
    },
    [SET_TOKEN](state, data) {
        state.token = data
    },
    [SET_QUERY_PARAMS](state, data) {
        state.queryParams = data
    },
    [SET_PROFILE](state, data) {
        state.profile = data
    },
    [SET_IDENTITY](state, data) {
        if (data === undefined) {
            data = null
        }
        state.identity = data
    },
    [SET_ADDRESSES](state, data) {
        state.addresses = data
    },
    [SET_ADDRESS_SUGGESTIONS](state, data) {
        state.addressSuggestions = data
    },
    [SET_GEO_ADDRESS](state, data) {
        state.geolocationAddress = data
    },
    [SET_INPUT_GEO_ADDRESS](state, data) {
        state.inputGeoAddress = data
    },
    [SET_IS_HAS_GEO](state, data) {
        state.isHasGeo = data
    },
}

export const actions = {

    async [SET_PROFILE_ADDRESS](context, { address }) {

        if (context.getters.loading[SET_PROFILE_ADDRESS]) {
            return
        }

        context.commit(SET_LOADING, { process: SET_PROFILE_ADDRESS, loading: true })

        return await axios({
            method: 'POST',
            data: {
                address,
                city_id: context.getters.guardCityID
            },
            url: api.profile.setAddress.url()
        }).then(response => {
            return response
        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
            return error.response
        }).finally(() => {
            context.commit(SET_LOADING, { process: SET_PROFILE_ADDRESS, loading: false })
        })
    },

    async [GET_ADDRESSES](context) {
        axios({
            method: 'GET',
            url: api.profile.getAddresses.url()
        }).then(response => {
            context.commit(SET_ADDRESSES, response.data)
        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        }).finally(() => {
            context.commit(SET_IS_HAS_GEO, true)
        })
    },

    async [GET_ADDRESS_SUGGESTIONS](context, { address_query }) {
        axios({
            method: 'POST',
            url: api.profile.getAddressSuggestions.url(),
            data: {
                address_query
            }
        }).then(response => {
            context.commit(SET_ADDRESS_SUGGESTIONS, response.data)
        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        })
    },

    async [GET_GEO_ADDRESS](context) {
        if (context.getters.loading[GET_GEO_ADDRESS]) {
            return
        }

        context.commit(SET_LOADING, { process: GET_GEO_ADDRESS, loading: true })

        navigator.geolocation.getCurrentPosition(pos => {



            // if (!context.getters.guardPass) {
            //     context.commit(SET_LOADING, { process: GET_GEO_ADDRESS, loading: false })
            //     return
            // }

            axios({
                method: 'POST',
                data: {
                    latitude: pos.coords.latitude,
                    longitude: pos.coords.longitude,
                    city_id: context.getters.guardCityID
                },
                url: api.profile.getGeoAddress.url()
            }).then(response => {
                let addressData = response.data
                addressData.geo = true
                addressData.lat = addressData.latitude
                addressData.lng = addressData.longitude
                context.commit(SET_GEO_ADDRESS, addressData)
                if (addressData.postcode) {
                    context.commit(SET_POST_CODE, addressData.postcode)
                }
                if (addressData.city) {
                    context.commit(SET_DELIVERY_TO_CITY, addressData.city)
                }
                if (addressData.street) {
                    context.commit(SET_DADATA_STREET, addressData.street)
                }
            }).catch(error => {
                context.commit(SET_GEO_ADDRESS, GEOLOCATION_ADDRESS_ERROR)
                context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
            }).finally(() => {
                context.commit(SET_LOADING, { process: GET_GEO_ADDRESS, loading: false })
                context.commit(SET_IS_HAS_GEO, true)
            })

        }, err => {
            context.commit(SET_GEO_ADDRESS, GEOLOCATION_ADDRESS_ERROR)
            context.commit(SET_LOADING, { process: GET_GEO_ADDRESS, loading: false })
        }, { timeout: 10000, enableHighAccuracy: true })

    },

    async [GET_INPUT_GEO_ADDRESS](context, { address, suggested }) {
        if (context.getters.loading[GET_INPUT_GEO_ADDRESS]) {
            return
        }

        context.commit(SET_LOADING, { process: GET_INPUT_GEO_ADDRESS, loading: true })

        axios({
            method: 'POST',
            data: {
                address,
                suggested,
                city_id: context.getters.guardCityID
            },
            url: api.profile.getGeoAddress.url()
        }).then(response => {
            let addressData = response.data
            addressData.inputGeo = true
            addressData.lat = addressData.latitude
            addressData.lng = addressData.longitude
            context.commit(SET_INPUT_GEO_ADDRESS, addressData)
            if (addressData.postcode) {
                context.commit(SET_POST_CODE, addressData.postcode)
            }
            if (addressData.city) {
                context.commit(SET_DELIVERY_TO_CITY, addressData.city)
            }
            if (addressData.street) {
                context.commit(SET_DADATA_STREET, addressData.street)
            }
        }).catch(error => {
            context.commit(SET_INPUT_GEO_ADDRESS, GEOLOCATION_ADDRESS_ERROR)
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        }).finally(() => {
            context.commit(SET_LOADING, { process: GET_INPUT_GEO_ADDRESS, loading: false })
            context.commit(SET_IS_HAS_GEO, true)
        })
    },

    async [SET_AREA](context, payload) {
        if (context.getters.loading[SET_AREA]) {
            return
        }

        context.commit(SET_LOADING, { process: SET_AREA, loading: true })

        return axios({
            method: 'POST',
            url: api.profile.setArea.url(),
            data: payload
        }).then(response => {
            if (response.data.outlet_id) {
                context.commit(SET_GUARD_OUTLET_ID, response.data.outlet_id)
            }
            if (response.data.identifier) {
                context.commit(SET_GUARD_PASS, response.data.identifier)
            }
            context.commit(SET_LOADING, { process: SET_AREA, loading: false })
        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        })
    }

}

export default {
    state,
    mutations,
    getters,
    actions
}